import React from 'react';
import { Spinner } from 'react-bootstrap';
import { enums } from '~/util';
import { moment, momentFormats } from '~/vendorConfigs/moment';
import { ReportType } from '../ListReports';

interface ReportRowProps {
    report: ReportType;
}
export function ReportRow({ report }: ReportRowProps) {
    const filterInfo = [];

    // The summary array will eventually have all of our info, but just provider name for now
    if (Array.isArray(report?.filters?.summary) && report.filters.summary.length > 0) {
        filterInfo.push(...report.filters.summary);
    }

    // add patient/provider info if available
    if (Array.isArray(report?.filters?.patient_gmpis) && report.filters.patient_gmpis.length > 0) {
        filterInfo.push('GMPI(s)');
    }

    // add date range filter info if available
    if (report?.filters?.from && report?.filters?.to) {
        filterInfo.push(
            `${moment(report.filters.from).format(momentFormats.DATE)} - ${moment(
                report.filters.to
            ).format(momentFormats.DATE)}`
        );
    }

    return (
        <tr>
            <td>{enums(['report', 'type', report.type])}</td>
            <td>{filterInfo.join(', ')}</td>
            <td>{moment(report.created_at).format(momentFormats.DATE)}</td>
            <td className="text-center position-relative">
                {enums(['report', 'status', report.status]) === 'Pending' && (
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        title="Processing"
                    />
                )}
                {enums(['report', 'status', report.status]) === 'Failed' && (
                    <i className="fa-solid fa-exclamation-circle" title="Failed" />
                )}
                {enums(['report', 'status', report.status]) === 'Created' && (
                    <a href={`/api/media/${report.media.uniqid}/download`} className="text-body">
                        <i className="fa-solid fa-download" title="Download Report">
                            <span className="sr-only">Download Report</span>
                        </i>
                    </a>
                )}
            </td>
        </tr>
    );
}
